import React from "react"
import { UncontrolledTooltip } from "reactstrap"
import { TrailerSize } from "../constants"

const DEFAULT_OPTIONS = {
   listKey: [
      "usedIn",
      "trailers",
      "appliedTrailers",
      "models",
      "configuratorTrailerPackages",
   ],
   emptyText: "-",
   tooltipPlacement: "top",
}

const defaultGetListForRow = (row, listKey) => {
   const keysToCheck = Array.isArray(listKey) ? listKey : [listKey]

   for (const key of keysToCheck) {
      const value = row?.[key]
      if (Array.isArray(value)) {
         return value
      }
   }

   return []
}

const defaultBuildTrailerName = item => {
   if (!item) {
      return null
   }

   const trailer =
      item?.trailer || item?.configuratorTrailer || item?.trailerType || null

   if (!trailer) {
      return null
   }

   const rawSize =
      Array.isArray(trailer?.configuratorTrailerSizeType) &&
      trailer.configuratorTrailerSizeType.length > 0
         ? trailer.configuratorTrailerSizeType[0]
         : null

   const size = rawSize ? TrailerSize.getDisplayTextKey(rawSize) : null

   const type =
      trailer?.trailerType?.trailerType ||
      (typeof trailer?.trailerType === "string" ? trailer.trailerType : null)

   const model =
      Array.isArray(trailer?.model) && trailer.model.length > 0
         ? trailer.model[0]
         : typeof trailer?.model === "string"
         ? trailer.model
         : null

   const parts = [size, type, model].filter(Boolean)

   return parts.length > 0 ? parts.join(" ") : null
}

const useRenderUsedIn = (userOptions = {}) => {
   const {
      listKey,
      emptyText,
      tooltipPlacement,
      getListForRow = defaultGetListForRow,
      buildTrailerName = defaultBuildTrailerName,
   } = {
      ...DEFAULT_OPTIONS,
      ...userOptions,
   }

   const renderUsedIn = row => {
      const list = getListForRow(row, listKey)
      const trailerNames = list.map(buildTrailerName).filter(Boolean)

      const first = trailerNames.length > 0 ? trailerNames[0] : emptyText
      const extraCount = trailerNames.length > 1 ? trailerNames.length - 1 : 0

      const tooltipId = `usedInTooltip-${row?.id || Math.random()}`

      return (
         <div className="d-flex align-items-center">
            <span id={tooltipId}>{first || emptyText}</span>
            {extraCount > 0 && (
               <>
                  <span className="ms-2 badge rounded-pill bg-light text-dark">
                     {`+${extraCount}`}
                  </span>
                  <UncontrolledTooltip
                     placement={tooltipPlacement}
                     target={tooltipId}
                     trigger="hover"
                  >
                     <div style={{ textAlign: "left" }}>
                        {trailerNames.length > 0 ? (
                           trailerNames.map((trailerName, index) => (
                              <div key={index}>{trailerName}</div>
                           ))
                        ) : (
                           <div>No trailer types available</div>
                        )}
                     </div>
                  </UncontrolledTooltip>
               </>
            )}
         </div>
      )
   }

   return renderUsedIn
}

export default useRenderUsedIn
